import Clarity from '@microsoft/clarity';

// Initialize Clarity
export const initClarity = () => {
    const clarityProjectId = "mh5j184oxy";
    try {
        // Replace 'YOUR_PROJECT_ID' with your actual Clarity project ID
        if (clarityProjectId) {
            Clarity.init(clarityProjectId);
            console.log('Clarity initialized successfully');
        } else {
            console.warn('Clarity project ID not found in environment variables');
        }
    } catch (error) {
        console.error('Failed to initialize Clarity:', error);
    }
};

// Event tracking function for Clarity
export const trackEvent = (eventName, properties = {}) => {
    try {
        if (typeof window !== 'undefined' && window.clarity) {
            Clarity.event(eventName, properties);
        }
    } catch (error) {
        console.warn('Clarity event tracking failed:', error);
    }
    
    // Console log for development
    console.log(`Event: ${eventName}`, properties);
};

// Set user metadata for Clarity
export const identifyUser = (userId, traits = {}) => {
    try {
        if (typeof window !== 'undefined' && window.clarity) {
            Clarity.identify(userId, traits);
        }
    } catch (error) {
        console.warn('Clarity identify failed:', error);
    }
};

export default {
    initClarity,
    trackEvent,
    identifyUser
};

